
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SocialMediaSectionProps {
  instagramUsername: string;
  linkedinUsername: string;
  onInstagramChange: (value: string) => void;
  onLinkedinChange: (value: string) => void;
}

const SocialMediaSection = ({
  instagramUsername,
  linkedinUsername,
  onInstagramChange,
  onLinkedinChange
}: SocialMediaSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="instagram_username">Instagram Username</Label>
        <div className="flex">
          <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-input bg-muted text-muted-foreground text-sm">
            @
          </span>
          <Input
            id="instagram_username"
            type="text"
            value={instagramUsername}
            onChange={(e) => onInstagramChange(e.target.value)}
            placeholder="yourusername"
            className="rounded-l-none"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="linkedin_username">LinkedIn Username</Label>
        <Input
          id="linkedin_username"
          type="text"
          value={linkedinUsername}
          onChange={(e) => onLinkedinChange(e.target.value)}
          placeholder="your-linkedin-username"
        />
      </div>
    </div>
  );
};

export default SocialMediaSection;
